import { Notification } from 'element-ui';

export default {
  async linkDomain() {
    this.validateSiteIdOrDomain();
    this.linkBtnLoading = true;
    this.linkBtnText = this.$t(
      'custom_domain.ui.domain_instruction.verify_button.text.verifying'
    );

    try {
      const response = await this.connectDomain({
        siteId: this.site.id,
        domain: this.domain,
        pathPrefix: this.pathSharingEnabled ? this.pathPrefix : undefined,
      });
      const check = response.data.check;
      let message = response.data.message;

      if (check) {
        if (message === 'owner_match') {
          this.unlinkExistingDomain = true;
          this.hostnameSiteId = response.data.hostnameSiteId || '';
          this.openUnlinkDialog(this.site.id, this.domain);
          return;
        }
        this.performCheckAction(message);
      } else if (!check) {
        if (message === 'already_linked') {
          return this.loadDomains();
        }
        this.performErrorNotification(message);
      }
    } catch (error) {
      console.error(error.message);
      this.linkBtnLoading = false;
      this.linkBtnText = this.$t(
        'custom_domain.ui.domain_instruction.verify_button.text.try_again'
      );

      Notification.error({
        message: 'An error occured',
        position: 'bottom-right',
      });
    }
  },
  async unlinkDomain(domain) {
    // update the domain data properties
    this.domain = domain;
    this.validateSiteIdOrDomain();

    if (
      this.unlinkExistingDomain &&
      this.hostnameSiteId &&
      this.pathPrefix &&
      this.pathSharingEnabled
    ) {
      this.unlinkDialog = false;
      try {
        const response = await this.connectDomain({
          siteId: this.hostnameSiteId,
          domain: this.domain,
          pathPrefix: this.pathPrefix,
          bindSiteId: this.site.id,
        });
        this.hostnameSiteId = '';
        this.unlinkExistingDomain = false;
        if (response.data.check && response.data.message !== 'owner_match') {
          this.performCheckAction(response.data.message);
          return;
        }
        if (!response.data.check && response.data.message === 'already_linked') {
          return this.loadDomains();
        }
        this.performErrorNotification(response.data.message);
      } catch (error) {
        console.error(error.message);
        this.performErrorNotification('custom_domain.error.general_error');
      }
      return;
    }

    let response = false;
    try {
      response = await this.disconnectDomain({
        siteId: this.site.id,
        domain: this.domain,
      });
    } catch (error) {
      console.error(error.message);
    }

    if (response) {
      this.$message({
        type: 'info',
        message: `${this.$t('custom_domain.success.domain_unlinked')} ${
          this.unlinkDomainName
        }`,
      });
      // reset the UI and data properties
      this.unlinkDomainSiteId = '';
      this.unlinkDomainName = '';
      this.unlinkDialog = false;
      this.unlinkExistingDomain = false;
      this.hostnameSiteId = '';
      this.performUiReset();
    } else {
      console.error(`${this.$t('custom_domain.error.unlink_dialog.part_one')}`);
      this.$message({
        type: 'warning',
        message: `${this.$t('custom_domain.error.unlink_dialog.part_one')}, ${
          this.unlinkDomainName
        }. ${this.$t('custom_domain.error.unlink_dialog.part_two')}`,
      });
    }
  },
  openUnlinkDialog(siteId, domain) {
    this.unlinkDomainSiteId = siteId;
    this.unlinkDomainName = domain;
    this.unlinkDialog = true;
  },
  openApexDialog() {
    this.apexDialog = true;
  },
  clearDomain() {
    this.showDomainInstruction = false;
    this.domain = '';
    this.pathPrefix = '';
    this.hostnameSiteId = '';
  },
  updateDomain({ target }) {
    this.domain = target.value;
  },
  updatePathPrefix(e) {
    const raw = e && e.target ? e.target.value : e || '';
    this.pathPrefix = String(raw).replace(/^\/+/, '');
  },
  performCheckAction(message) {
    this.performUiReset();
    this.linkSuccessMessage = this.$t(message);
    setTimeout(() => {
      this.linkSuccessMessage = '';
    }, 5000);
  },
  performErrorNotification(message) {
    // TODO:
    // The connect button in custom-domain-actions.jsx is not reactive and
    // its disable attribute is reliant on showDomainInstructions value of false.
    // This button needs its own disabling property to fix the issue.

    this.linkBtnLoading = false;
    this.linkBtnText = this.$t(
      'custom_domain.ui.domain_instruction.verify_button.text.try_again'
    );
    this.clearDomain();
    Notification.error({ message: this.$t(message), position: 'bottom-right' });
  },
  performUiReset() {
    this.loadDomains();
    this.linkBtnLoading = false;
    this.linkBtnText = this.$t(
      'custom_domain.ui.domain_instruction.verify_button.text.verify'
    );
    this.clearDomain();
  },
};
